import { route, subGroup, meta } from '@/helpers/routes'

import DashboardProfessional from './gadget/index'

console.log(window.location.href)

const routes = [
  route('index', ':cnpj', DashboardProfessional, meta('Perfil profissional pessoa jurídica', true, 'guest'))
]

export default subGroup('/', routes)



// WEBPACK FOOTER //
// ./src/app/patient/profile-company/routes.js